// Type definitions for the Admin SiteSettings endpoints.
// Field names intentionally match the backend payload exactly, including the
// baked-in misspellings (e.g. `WidhtrawApiKey`, `IsAuto*Widthraw`).

/* ------------------------------------------------------------------ */
/* Authentication                                                     */
/* ------------------------------------------------------------------ */

export interface AuthenticationServiceSettings {
    name: string;
    apiKey?: string;
    secretKey?: string;
    biometricSettingsToken?: string;
    token?: string;
    isActive: boolean;
}

export interface AuthenticationServicesSettingsDto {
    authenticationServices: AuthenticationServiceSettings[];
}

export interface BiometricSettings {
    manualAuthenticate: boolean;
    biometricAuthenticate: boolean;
    line: string;
    // `words` is write-only (accepted on update, not returned on read)
    words?: string;
}

/* ------------------------------------------------------------------ */
/* Payment gateways                                                   */
/* ------------------------------------------------------------------ */

// GatewayName enum: Zibal = 1, Vandar = 2, Jibit = 3, PayStar = 4
export enum GatewayName {
    Zibal = 1,
    Vandar = 2,
    Jibit = 3,
    PayStar = 4,
}

export interface GatewaySettingItem {
    serviceName: GatewayName;
    apiKey: string;
    isDepositActive: boolean;
    isWithdrawActive: boolean;
}

export interface GatewaySettingDto {
    items?: GatewaySettingItem[];
}

export interface JibitPaymentSettings {
    secretKey?: string;
    apiKey?: string;
    widhtrawApiKey?: string;
    withdrawsecretKey?: string;
    cashInApiKey?: string;
    cashInSecretKey?: string;
}

export interface VandarSettings {
    token: string;
    refreshToken: string;
    businessName: string;
    expirationDate?: string | null;
}

export interface ZibalSettings {
    apiKey: string;
    walletId: string;
}

export interface PayStarSettings {
    key: string;
    walletHashId: string;
    password: string;
    withdrawlSign: string;
    withdrawlApiKey: string;
    refreshTokenWallet: string;
    applicationId: string;
    accessPassword: string;
    refreshTokenCoBank: string;
    accountNumber: string;
}

export interface PakatSettings {
    apiKeyV3: string;
}

/* ------------------------------------------------------------------ */
/* Financial & trade                                                  */
/* ------------------------------------------------------------------ */

export interface CommissionSettings {
    commission: number;
}

export interface TradeAmountLimitSettings {
    cryptoMinTradeAmount: number;
    utopiaMinTradeAmount: number;
    irtMinTradeAmount: number;
}

export interface SucceedBuyOrderLimitConditionsSettings {
    withoutLimits: number;
    maxAmountForDocument: number;
}

export interface DangerousAmountsSettings {
    forLevel1: number;
    forLevel2: number;
}

export interface WithdrawKindSettings {
    isAutoCryptoWidthraw: boolean;
    isAutoCurrencyWidthraw: boolean;
    isAutoUtopiaWidthraw: boolean;
}

export interface CryptoWithdrawalFeeSettings {
    trx: number;
    usdt: number;
    bep20StableCoin: number;
}

/* ------------------------------------------------------------------ */
/* External services                                                  */
/* ------------------------------------------------------------------ */

export interface PerfectMoneySettings {
    accountId: string;
    payeeAccount: string;
    password: string;
}

export interface UtopiaSettings {
    token: string;
    baseUrl: string;
}

export interface KucoinCredentialsSettings {
    apiKey: string;
    apiSecret: string;
    apiPassPhrase: string;
}

export interface Tron24Settings {
    apiKey: string;
    secretKey: string;
    hotWalletAddress: string;
    commissionWalletAddress: string;
}
